// utils/numberToWords.js
export const numberToWords = (number) => {
    if (isNaN(number) || number === null || number === undefined) {
      return "Invalid number";
    }
  
    if (number === 0) return "Zero";
  
    const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const thousands = ["", "Thousand", "Million", "Billion", "Trillion"];
  
    const convertToWords = (num) => {
      let result = "";
      let i = 0;
      
      while (num > 0) {
        if (num % 1000 !== 0) {
          result = convertLessThanOneThousand(num % 1000) + thousands[i] + " " + result;
        }
        num = Math.floor(num / 1000);
        i++;
      }
      
      return result.trim();
    };
  
    const convertLessThanOneThousand = (num) => {
      let result = "";
      if (num % 100 < 20) {
        result = ones[num % 100];
        num = Math.floor(num / 100);
      } else {
        result = ones[num % 10];
        num = Math.floor(num / 10);
        result = tens[num % 10] + " " + result;
        num = Math.floor(num / 10);
      }
      if (num === 0) return result;
      return ones[num] + " Hundred " + result;
    };
  
    return convertToWords(Math.floor(number));
  };
  